import { useSelector, useDispatch } from 'react-redux';
import React from 'react'
import Select from "react-select";
import {
  fetchAssociationLov,
  selectedObjectTypeFilterSelector,
  setSelectedAssociationFilter,
  setSelectedObjectTypeFilter
} from 'stores/redux/slice/manageCommitte';

const all = { label: 'All', value: '' }

export default function ObjectTypeLov({ name, label, lov, gridController }) {
  const selectedValue = useSelector(selectedObjectTypeFilterSelector);
  const dispatch = useDispatch();
  return (
    <>
      <label htmlFor={`filter-${name}`} className="invisible">
        {label}
      </label>
      <Select
        value={selectedValue}
        className="grid-reactSelect-wrapper"
        classNamePrefix="grid-reactSelect"
        id={`filter-id-${name}`}
        inputId={`filter-${name}`}
        data-id={`filter-${name}`}
        options={[all, ...lov]}
        name={name}
        defaultValue={all}
        menuPosition="absolute"
        menuPortalTarget={document.body}

        classNames={{
          option: () => `menu-item-${name}`

        }}
        onChange={(option) => {
          dispatch(setSelectedObjectTypeFilter(option))
          dispatch(setSelectedAssociationFilter(all))
          dispatch(fetchAssociationLov({ association: 'All', objtype: option?.value }))
          gridController.current.filterExternally({
            'objectType': option?.value,
            esysId: ''
          }, false);

        }}
        styles={{ menuPortal: (base) => ({ ...base, minWidth: "10rem", zIndex: 999 }) }}
      />
    </>

  )
}


